<h2 class="heading-4">Your repair is approved</h2>

<p class="body">
  To book a date and time, please call {{ vm.repairer | titlecase }} directly.
  <app-telephone-link [phoneNumber]="vm.contactNumber" [useButtonOnMobile]="true" />
</p>

<section class="divider"></section>

<p class="hint">
  {{ vm.callCostMessaging }}
</p>
